import React, { useEffect, useState } from 'react';
import { view } from '@forge/bridge';

import { PortalEdit } from './components/edit/PortalEdit';
import { FieldEntryPoint } from './pages/FieldEntryPoint';
import { Gadget } from './pages/gadget';
import { GetStartedEntryPoint } from './pages/get-started/view';
import { JiraexpEntryPoint } from './pages/jiraexp/jiraexpEntryPoint';
import { RegexEntryPoint } from './pages/regex/RegexEntryPoint';

const App: React.FC = () => {
    const [moduleKey, setModuleKey] = useState<string>('');
    const [isCompleted, setIsCompleted] = useState<boolean>(false);

    const fetchData = async () => {
        const context = await view.getContext();
        setModuleKey(context.moduleKey);
        setIsCompleted(true);
    };

    useEffect(() => {
        void fetchData();
    }, []);

    const MODULES: any = {
        'multilevel-cascading-custom-field-type': <FieldEntryPoint />,
        'custom-field-regex-type': <RegexEntryPoint />,
        'custom-field-jira-expression-type': <JiraexpEntryPoint />,
        'portal-create-request-panel-customfield-value': <PortalEdit />,
        'cf-field-values-gadget': <Gadget />,
        'admin-page-custom-fields-suite-get-started': <GetStartedEntryPoint />,
    };

    return isCompleted ? MODULES[moduleKey] : <div>loading...</div>;
};

export default App;
